import { render, staticRenderFns } from "./Chat-list.vue?vue&type=template&id=1f25935f&"
import script from "./Chat-list.vue?vue&type=script&lang=js&"
export * from "./Chat-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports